export default "../css/794d9088b379877bfe7eb5278ba48d21.ttf";